<template>
    <h1>Agrolink users page</h1>
</template>

<script>
export default {
    name: "Users",
    data() {
        return {
            metaUrl: '/users',
        }
    }
}
</script>

<style scoped>

</style>
